import React from 'react';

const Icon = (props) => {
  const { classNames } = props;

  return (
    <div className={classNames} />
  );
};

export default Icon;
